import { SearchFilters } from '@/constants/listing-search-keys';

enum FILTERGROUP {
  PRICE_RANGE = 'Price Range',
  ROOMS_AND_SPACES = 'Rooms & Spaces',
  PETS = 'Pets',
  PROPERTY_FEATURES = 'Property Features',
  VIEWS = 'Views',
}

enum FILTERTYPE {
  BUTTON = 'button',
  RANGE = 'range',
  NUMBER = 'number',
  STEPPER = 'stepper',
}

enum FILTERORDER {
  PRICE_RANGE,
  ROOMS_AND_SPACES,
  PETS,
  PROPERTY_FEATURES,
  VIEWS,
}

export const findFilterByKey = (
  filters: ClientBrandFilter[],
  key: SearchFiltersValues
): ClientBrandFilter | undefined => {
  return filters.find((filter) => filter.key === key);
};

export const orderFilters = (
  filters: { group: keyof typeof FILTERORDER }[]
) => {
  return filters.sort((a, b) => FILTERORDER[a.group] - FILTERORDER[b.group]);
};

const MRR_RANGE_FILTERS: RangeFilter[] = [
  {
    key: [SearchFilters.MIN_AMOUNT, SearchFilters.MAX_AMOUNT],
    label: 'Total Price Before Taxes',
    type: FILTERTYPE.RANGE,
    min: 0,
    max: 10000,
    group: FILTERGROUP.PRICE_RANGE,
  },
];

const MRR_NUMBER_FILTERS: NumberFilter[] = [
  {
    key: SearchFilters.BEDROOMS,
    label: 'Bedrooms',
    type: FILTERTYPE.NUMBER,
    multiple: true,
    min: 1,
    max: 10,
    group: FILTERGROUP.ROOMS_AND_SPACES,
  },
];

const MRR_STEPPER_FILTERS: StepperFilter[] = [
  {
    key: SearchFilters.BEDS,
    label: 'Beds',
    type: FILTERTYPE.STEPPER,
    options: [
      { label: '1+', value: '1' },
      { label: '2+', value: '2' },
      { label: '3+', value: '3' },
      { label: '4+', value: '4' },
      { label: '5+', value: '5' },
      { label: '6+', value: '6' },
      { label: '7+', value: '7' },
      { label: '8+', value: '8' },
    ],
    group: FILTERGROUP.ROOMS_AND_SPACES,
  },
  {
    key: SearchFilters.BATHROOMS,
    label: 'Bathrooms',
    type: FILTERTYPE.STEPPER,
    options: [
      { label: '1+', value: '1' },
      { label: '2+', value: '2' },
      { label: '3+', value: '3' },
      { label: '4+', value: '4' },
      { label: '5+', value: '5' },
      { label: '6+', value: '6' },
      { label: '7+', value: '7' },
      { label: '8+', value: '8' },
    ],
    group: FILTERGROUP.ROOMS_AND_SPACES,
  },
];

const MRR_BUTTON_FILTERS: ButtonFilter[] = [
  {
    key: SearchFilters.UNIT_VIEWS,
    value: 'oceanfront',
    label: 'Oceanfront',
    type: FILTERTYPE.BUTTON,
    group: FILTERGROUP.VIEWS,
  },
  {
    key: SearchFilters.UNIT_VIEWS,
    value: 'ocean',
    label: 'Ocean View',
    type: FILTERTYPE.BUTTON,
    group: FILTERGROUP.VIEWS,
  },
  {
    key: SearchFilters.UNIT_VIEWS,
    value: 'garden',
    label: 'Garden View',
    type: FILTERTYPE.BUTTON,
    group: FILTERGROUP.VIEWS,
  },
  {
    key: SearchFilters.UNIT_VIEWS,
    value: 'mountain',
    label: 'Mountain View',
    type: FILTERTYPE.BUTTON,
    group: FILTERGROUP.VIEWS,
  },
  {
    key: SearchFilters.UNIT_VIEWS,
    value: 'ground',
    label: 'Ground Floor',
    type: FILTERTYPE.BUTTON,
    group: FILTERGROUP.VIEWS,
  },
];

export const MRR_FILTERS: ClientBrandFilter[] = [
  ...MRR_RANGE_FILTERS,
  ...MRR_NUMBER_FILTERS,
  ...MRR_STEPPER_FILTERS,
  ...MRR_BUTTON_FILTERS,
];
export const MRR_FEATURED_CATEGORIES = [
  {
    label: 'Ocean View',
    filters: [
      {
        key: SearchFilters.UNIT_VIEWS,
        value: 'ocean',
      },
    ],
  },
  {
    label: 'Oceanfront',
    filters: [
      {
        key: SearchFilters.UNIT_VIEWS,
        value: 'oceanfront',
      },
    ],
  },
  {
    label: 'Ground Floor',
    filters: [{ key: SearchFilters.UNIT_VIEWS, value: 'ground' }],
  },
];

// ----------------------------

const BVR_RANGE_FILTERS: RangeFilter[] = [
  {
    key: [SearchFilters.MIN_AMOUNT, SearchFilters.MAX_AMOUNT],
    label: 'Total Price Before Taxes',
    type: FILTERTYPE.RANGE,
    min: 0,
    max: 10000,
    group: FILTERGROUP.PRICE_RANGE,
  },
];

const BVR_NUMBER_FILTERS: NumberFilter[] = [
  {
    key: SearchFilters.BEDROOMS,
    label: 'Bedrooms',
    type: FILTERTYPE.NUMBER,
    multiple: true,
    min: 1,
    max: 10,
    group: FILTERGROUP.ROOMS_AND_SPACES,
  },
];

const BVR_STEPPER_FILTERS: StepperFilter[] = [
  {
    key: SearchFilters.BEDS,
    label: 'Beds',
    type: FILTERTYPE.STEPPER,
    options: [
      { label: '1+', value: '1' },
      { label: '2+', value: '2' },
      { label: '3+', value: '3' },
      { label: '4+', value: '4' },
      { label: '5+', value: '5' },
      { label: '6+', value: '6' },
      { label: '7+', value: '7' },
      { label: '8+', value: '8' },
    ],
    group: FILTERGROUP.ROOMS_AND_SPACES,
  },
  {
    key: SearchFilters.BATHROOMS,
    label: 'Bathrooms',
    type: FILTERTYPE.STEPPER,
    options: [
      { label: '1+', value: '1' },
      { label: '2+', value: '2' },
      { label: '3+', value: '3' },
      { label: '4+', value: '4' },
      { label: '5+', value: '5' },
      { label: '6+', value: '6' },
      { label: '7+', value: '7' },
      { label: '8+', value: '8' },
    ],
    group: FILTERGROUP.ROOMS_AND_SPACES,
  },
  {
    key: SearchFilters.MAX_PETS,
    label: 'Max Pets',
    type: FILTERTYPE.STEPPER,
    options: [
      { label: '1', value: '1' },
      { label: '2', value: '2' },
      { label: '3', value: '3' },
      { label: '4', value: '4' },
    ],
    group: FILTERGROUP.PETS,
  },
];

const BVR_BUTTON_FILTERS: ButtonFilter[] = [
  {
    key: SearchFilters.PETS,
    value: '1',
    label: 'Dog Friendly',
    type: FILTERTYPE.BUTTON,
    group: FILTERGROUP.PROPERTY_FEATURES,
  },
  {
    key: SearchFilters.FEATURES,
    value: 'ac',
    label: 'Air Conditioning',
    type: FILTERTYPE.BUTTON,
    group: FILTERGROUP.PROPERTY_FEATURES,
  } as ButtonFilter,
  {
    key: SearchFilters.FEATURES,
    value: 'waterfront',
    label: 'Oceanfront',
    type: FILTERTYPE.BUTTON,
    group: FILTERGROUP.PROPERTY_FEATURES,
  },
  {
    key: SearchFilters.FEATURES,
    value: 'steps_to_sand',
    label: 'Steps to Sand',
    type: FILTERTYPE.BUTTON,
    group: FILTERGROUP.PROPERTY_FEATURES,
  },
  {
    key: SearchFilters.MAX_GUESTS,
    value: '10',
    label: 'Max Occupants 10+',
    type: FILTERTYPE.BUTTON,
    group: FILTERGROUP.PROPERTY_FEATURES,
  },
  {
    key: SearchFilters.FEATURES,
    value: 'lux',
    label: 'Luxury Homes',
    type: FILTERTYPE.BUTTON,
    group: FILTERGROUP.PROPERTY_FEATURES,
  },
  //? This filter currently returns no matchs
  // {
  //   key: SearchFilters.FEATURES,
  //   value: 'single_family',
  //   label: 'Single Family Home',
  //   type: FILTERTYPE.BUTTON,
  //   group: FILTERGROUP.PROPERTY_FEATURES,
  // },
];

export const BVR_FILTERS: ClientBrandFilter[] = [
  ...BVR_RANGE_FILTERS,
  ...BVR_NUMBER_FILTERS,
  ...BVR_STEPPER_FILTERS,
  ...BVR_BUTTON_FILTERS,
];
